const {Component} = require("react");
const PropTypes = require("prop-types");
const {pluckKeysExcept} = require("app/util/object");
const {normalizeRestrictedInput} = require("app/util/text");

class Textarea extends Component {

	static get propTypes() {
		return {
			limitLines: PropTypes.number,
			maxLength: PropTypes.number,
			onInput: PropTypes.func,
			defaultValue: PropTypes.any
		};
	}

	constructor(props) {
		super(props);
		this.state = {
			linesLeft: this.props.limitLines,
			charsLeft: this.props.maxLength
		};
	}

	get name() {
		return this.props.name;
	}

	get value() {
		return this.inputElement ? this.inputElement.value : "";
	}

	onInput = (e) => {
		let value = e.target.value = normalizeRestrictedInput(e.target.value);

		if (this.props.limitLines) {
			const lines = value.split("\n");
			let mergedLines = lines.slice(0, this.props.limitLines - 1);

			if (lines.length >= this.props.limitLines) {
				mergedLines.push(lines.slice(this.props.limitLines - 1).join(""));
			}

			this.setState({linesLeft: this.props.limitLines-lines.length});

			e.target.value = mergedLines.join("\n");
		}

		this.setState({charsLeft: this.props.maxLength-value.length});

		if (typeof this.props.onInput === "function") {
			this.props.onInput(e, this.state.linesLeft < 0 ? 0:this.state.linesLeft, this.state.charsLeft);
		}
	};

	render() {
		const props = pluckKeysExcept(this.props, ["limitLines"]);

		return (
			<textarea ref={el => this.inputElement = el} {...props} onInput={this.onInput} defaultValue={this.props.defaultValue} />
		);
	}

}

module.exports = Textarea;